<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item">
          <a href="#">{{translations('navbar.inventory_control')}}</a>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{translations('discard.archive_discard')}}</li>
      </ol>
    </nav>
    <div class="container-fluid main-container">
      <div class="form-inline mb-4 justify-content-between">
        <div class="d-flex flex-wrap">
          <div class="form-group mr-2">
            <router-link class="btn btn-primary" type="button" to="/new-discard">{{translations('common.addition')}}</router-link>
          </div>
          <div class="form-group mr-1">
            <input id='dtSearch' type="text" class="form-control" v-model='dtSearch' :placeholder="translations('common.keyword_search')">
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_partners.find(m => m.id === manufacturers_id) || ''"
              :options="master_partners"
              label="name"
              :placeholder="translations('discard.manufacturer')"
              :id="manufacturers_id"
              @input="changedMasterPartner">
            </v-select>
          </div>
          <div class="form-group mr-3">
            <v-select
              :value="master_mywarehouses.find(m => m.id === warehouse_id) || ''"
              :options="master_mywarehouses"
              label="name"
              :placeholder="translations('discard.warehouse_selection')"
              :id="warehouse_id"
              @input="changedMasterWarehouse">
            </v-select>
          </div>
          <div class="form-group mr-3 d-flex flex-wrap">
            <span class="mr-1">{{translations('common.period')}}</span>
            <input v-model="dateFrom" type="date" class="form-control">
            <span class="mr-1 ml-1">〜</span>
            <input v-model="dateTo" type="date" class="form-control">
          </div>
          <div class="form-group mr-2">
            <div class="dropdown">
              <button id='filterByBilling' class="btn btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                {{ getDivisionTypesTxt(translatedDivisionTypes, division_type, 'name', translations('discard.全部')) }}
              </button>
              <div class="dropdown-menu">
                <a class='dropdown-item' v-for='(division, i) in translatedDivisionTypes' :key='i' v-on:click='division_type=division.id'>{{ division.name }}</a>
              </div>
            </div>
          </div>
          <div class="form-group mr-2">
            <div class="form-check">
              <input v-model="displayAll" class="form-check-input pointer-clickable" id="displayAll" type="checkbox" value="" >
              <label class="form-check-label pointer-clickable" for="displayAll">
                {{translations('common.display_all')}}
              </label>
            </div>
          </div>
          <div class="form-group">
            <button class="btn btn-primary btn-sm" type="button" @click="submitSearch">{{translations('common.search')}}</button>
          </div>
        </div>
      </div>
      <div class="table-scroll mb-4">
        <v-data-table
          class="table table-striped table-hover table-1500 table-clickable table-no-margin"
          item-key="name"
          :headers="translatedHeader"
          :items="discards"
          :options.sync="options"
          :server-items-length="totalCount"
          hide-default-footer
          @page-count="pageCount = $event"
        >
          <template v-slot:body="{ items }">
            <tbody class="nowrap">
            <template v-if="!isEmpty">
              <tr  v-for="(discard, i) in items" :key='i' data-href="" @click="openSingleDiscards(discard)">
                <td>{{ i+1 }}</td>
                <td>
                    <span class="badge" :class="getStatusClass(discard.is_processed)">
                      {{ getStatusLabel(discard.is_processed) }}
                    </span>
                </td>
                <td>{{ $invoiceTools.formatDate(discard.apply_date) }}</td>
                <td>{{ $invoiceTools.formatDate(discard.discard_date) }}</td>
                <td>{{ discard.discard_number }}</td>
                <td>{{ discard.kaishu_partner_name }}</td>
                <td>{{ discard.kaishu_warehouse_name }}</td>
                <td>
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">
                      <span v-if="detail.product_condition !== null && detail.product_condition !== undefined" class="badge" :class="(Number(detail.product_condition) === 0) ? 'badge-success' : ((Number(detail.product_condition) === 2) ? 'badge-warning' : 'badge-danger')">
                        {{ (Number(detail.product_condition) === 0) ? translations('inventory.good') : ((Number(detail.product_condition) === 2) ? translations('inventory.outlet') : translations('inventory.bad')) }}
                      </span>
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">{{detail.jan_code || '&nbsp;'}}</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">{{detail.model || '&nbsp;'}}</li>
                  </ul>
                </td>
                <td class="right">
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">{{detail.quantity.toLocaleString()}}</li>
                  </ul>
                </td>
                <td class="right">
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">
                      <span v-if="Number(detail.tax_status) === 2">{{ detail.unit_price_inctax.toLocaleString() }}</span>
                      <span v-else>{{ detail.unit_price.toLocaleString() }}</span>
                    </li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">{{detail.client_order_number || '&nbsp;'}}</li>
                  </ul>
                </td>
                <td>
                  <ul>
                    <li v-for="(detail, i) in discard.details" :key="i">{{detail.remarks || '&nbsp;'}}</li>
                  </ul>
                </td>
                <td>{{ discard.requester_name || ' '}}</td>
                <td>{{ discard.reason || ' '}}</td>
                <td>{{ getDivisionTypesTxt(translatedDivisionTypes, discard.division_type, 'name', ' ') }}</td>
                <td>{{ discard.memo }}</td>
              </tr>
            </template>
            <template v-else>
              <tr class="odd">
                <td valign="top" colspan="12" class="dataTables_empty">{{ isEmptyMsg }}</td>
              </tr>
            </template>
            </tbody>
          </template>
        </v-data-table>
      </div>
      <v-pagination v-model="page" :length="pageCount" :total-visible="11"></v-pagination>
    </div>
    <vue-element-loading :active="isSearching" :is-full-screen="true"/>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { DiscardStatus } from '@/constants'
import { mapState } from 'vuex'

export default {
  name: 'ArchiveDiscards',
  props: {},
  components: {
    VueElementLoading
  },
  data () {
    return {
      discards: [],
      manufacturers_id: 0,
      warehouse_id: 0,
      division_type: 'A',
      dtSearch: '',
      isSearching: false,
      isEmpty: false,
      isEmptyMsg: '',
      dateTo: '',
      dateFrom: '',
      page: 1,
      pageCount: 0,
      totalCount: 0,
      displayAll: false,
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: [],
        sortDesc: [],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: false
      },
      divisionTypes: [
        { id: 'A', name: '全部' },
        { id: 'F', name: '廃棄' },
        { id: 'G', name: '追加' }
      ]
    }
  },
  computed: {
    ...mapState(['currentLanguage']),
    translatedDivisionTypes () {
      return this.divisionTypes.map(divisionType => {
        return {
          id: divisionType.id,
          name: this.translations(`discard.${divisionType.name}`)
        }
      })
    },
    translatedHeader () {
      const headers = [
        { text: 'No', value: '', sortable: false },
        { text: 'discard.discard_status', value: 'is_processed' },
        { text: 'discard.application_date', value: 'apply_date' },
        { text: 'discard.disposal_date', value: 'discard_date' },
        { text: 'discard.organization_number', value: 'discard_number' },
        { text: 'discard.manufacturer', value: 'kaishu_partner_name' },
        { text: 'discard.warehouse', value: 'kaishu_warehouse_name' },
        { text: 'discard.commodity_condition', value: 'product_condition' },
        { text: 'discard.jan_code', value: 'jan_code' },
        { text: 'discard.model', value: 'model' },
        { text: 'discard.quantity', value: 'quantity' },
        { text: 'discard.unit_price', value: 'unit_price' },
        { text: 'No.', value: 'client_order_number' },
        { text: 'discard.summary', value: 'remarks' },
        { text: 'discard.applicant', value: 'requester_name' },
        { text: 'discard.reason', value: 'reason' },
        { text: 'discard.division', value: 'division_type' },
        { text: 'discard.remarks', value: 'memo' }
      ]

      return headers.map(header => ({
        ...header,
        text: this.translations(header.text)
      }))
    },
    master_partners () {
      return this.$store.getters['Master/getPartners']
    },
    master_mywarehouses () {
      return this.$store.getters['Master/getMywarehouses']
    }
  },
  watch: {
    page () {
      this.getFilterdList()
    },
    options: {
      handler () {
        this.initList()
      },
      deep: true
    }
  },
  created: function () {
    this.$store.dispatch('Master/checkPartners')
    this.$store.dispatch('Master/checkMywarehouses')
    let storedFilter = this.$storage.get('ArchiveDiscardsParam')

    if (storedFilter) {
      this.dtSearch = storedFilter.search
      this.manufacturers_id = storedFilter.manufacturers_id
      this.warehouse_id = storedFilter.warehouse_id
      this.dateFrom = storedFilter.start_at
      this.dateTo = storedFilter.end_at
      this.options.sortBy = storedFilter.orderbys
      this.options.sortDesc = storedFilter.is_descs
      this.status_id = storedFilter.status_id
    }
    this.initList()
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    getStatusClass (status) {
      if (Number(status) === DiscardStatus.NOT_PROCESSED) {
        return 'badge-info'
      } else if (Number(status) === DiscardStatus.PROCESSED) {
        return 'badge-success'
      }
    },

    getStatusLabel (status) {
      if (Number(status) === DiscardStatus.NOT_PROCESSED) {
        return this.translations('discard.unprocessed')
      } else if (Number(status) === DiscardStatus.PROCESSED) {
        return this.translations('discard.processed')
      }
    },

    initList () {
      if (this.page !== 1) {
        this.page = 1
      } else {
        this.getFilterdList()
      }
    },

    getFilterdList () {
      if (this.isSearching) {
        return
      }

      if (this.displayAll) {
        this.options.itemsPerPage = -1
      } else {
        this.options.itemsPerPage = 10
      }

      this.isSearching = true

      const offset = (this.page - 1) * this.options.itemsPerPage
      const limit = this.options.itemsPerPage
      const orderbys = JSON.parse(JSON.stringify(this.options.sortBy))
      const isDescs = JSON.parse(JSON.stringify(this.options.sortDesc))

      let params = {
        manufacturers_id: this.manufacturers_id,
        warehouse_id: this.warehouse_id,
        start_at: this.dateFrom,
        end_at: this.dateTo,
        offset: offset,
        limit: limit,
        orderbys: orderbys,
        is_descs: isDescs,
        search: this.dtSearch,
        division_type: this.division_type
      }

      this.$storage.set('ArchiveDiscardsParam', params)
      console.log('ArchiveDiscards:getFilterdDiscardList: ', params)

      return this.$http.post(this.$api_url.discard_list, params).then(response => {
        const result = response.data
        if (result.status === true) {
          this.isEmpty = false
          this.isEmptyMsg = ''
          this.discards = result.list
          this.totalCount = Number(result.total_count)
        } else {
          this.discards = []
          this.$toastr.error(result.message, this.translations('common.error'))
        }
      }).catch(e => {
        console.log('ArchiveDiscards:API:getFilterdList: error: ', e)
        this.isEmpty = true
        this.isEmptyMsg = this.translations('discard.notice_failed')
        this.$toastr.error(this.isEmptyMsg, this.translations('common.error'))
      }).finally(() => {
        this.isSearching = false
        this.$nextTick(() => {
          this.$vuetify.goTo('.table-scroll', { duration: 0 })
        })
      })
    },

    openSingleDiscards (discard) {
      this.$router.push({ name: 'single-discard', query: { discard_id: discard.id } })
    },

    changedMasterPartner (event) {
      if (!event) {
        this.manufacturers_id = 0
        return
      }
      this.manufacturers_id = event.id
    },

    changedMasterWarehouse (event) {
      if (!event) {
        this.warehouse_id = 0
        return
      }
      this.warehouse_id = event.id
    },

    sliceNote (note) {
      let text = ''
      if (note) {
        let noteLength = note.length
        text = noteLength > 15 ? note.slice(0, 15) + '.....' : note
      }
      return text
    },

    getDivisionTypesTxt (obj, input, output, _default) {
      if (input) {
        return this.$invoiceTools.getObjPropsById(obj, input, output)
      }
      return _default
    },

    submitSearch () {
      this.initList()
    }
  }
}
</script>

<style>
#tbl-orders_wrapper .col-sm-12{
  padding-right: 0 !important;
}
</style>
